import * as React from 'react';
import { connect } from 'react-redux';

import {
  Grid,
  InfiniteScroller,
  Spinner,
  Typography,
} from '@upperhand/playmaker';
import CompanyLogo from 'components/CompanyLogo';
import AvatarWithTextContainer from 'components/AvatarWithTextContainer';
import MainHeader from 'components/MainHeader';
import SessionTimeAndResource from 'components/SessionTimeAndResource';

import { sessionSource } from 'sources';
import { getAvatarContent } from 'types/Staff';
import { resetScrollPosition } from 'utils/browser';

import { sessionActions, clientActions } from 'store/actions/dataSources';

import './AttendanceList.css';
import Attendee from 'containers/AttendanceList/components/Attendee';
import FullPageError from 'components/errors/FullPageError';

class AttendanceList extends React.PureComponent {
  state = {
    isCheckInPending: false,
  };

  async componentDidMount() {
    const { fetchSession } = this.props;

    await fetchSession();

    resetScrollPosition();
  }

  handleScroll = () => {
    const { listClients, page } = this.props;

    listClients({
      page: page + 1,
    });
  };

  handleClickCheckIn = clientId => {
    const { event, session, clients, history } = this.props;

    this.setState({ isCheckInPending: true }, async () => {
      await sessionSource.checkIn(session.id, [clientId]);

      const client = clients[clientId];

      history.push(`/sessions/${session.id}/confirm`, {
        sessionName: event.title,
        client,
      });
    });
  };

  render() {
    const {
      clientIds,
      error,
      event,
      isLoading,
      resources,
      session,
      staff,
      isLoadingClients,
      totalCount,
      hasMore,
    } = this.props;

    const { isCheckInPending } = this.state;

    const isComponentLoading = isLoading || isCheckInPending;

    const staffAvatarContent = getAvatarContent(staff);

    if (error) {
      return <FullPageError />;
    }

    return (
      <>
        <MainHeader backToLink="/sessions" />
        <div className="MainContent">
          <Grid container spacing={5} direction="column">
            {isComponentLoading || !session ? (
              <Grid container item justify="center">
                {isComponentLoading ? <Spinner /> : 'Session not found'}
              </Grid>
            ) : (
              <>
                <Grid item>
                  <header>
                    <Grid
                      container
                      justify="space-between"
                      wrap="nowrap"
                      alignItems="center"
                    >
                      <AvatarWithTextContainer
                        avatarName={staffAvatarContent.avatarName}
                        primaryText={event.title}
                        src={staffAvatarContent.src}
                        subText={staffAvatarContent.subText}
                      />
                      <Grid item>
                        <CompanyLogo />
                      </Grid>
                      <SessionTimeAndResource
                        session={session}
                        resources={resources}
                      />
                    </Grid>
                  </header>
                </Grid>

                <Grid item>
                  <InfiniteScroller
                    hasMore={hasMore}
                    onScroll={this.handleScroll}
                    isLoading={isLoadingClients}
                    loader={
                      <Grid container justify="center" spacing={3}>
                        <Grid item>
                          <Spinner />
                        </Grid>
                      </Grid>
                    }
                    showLoader
                  >
                    <Grid container spacing={3}>
                      <Grid item xs={12} className="attendance-header">
                        <div className="attendance-header__text">
                          <Typography variant="h3">
                            {totalCount === 1
                              ? '1 Attendee'
                              : `${totalCount} Attendees`}
                          </Typography>
                        </div>
                      </Grid>
                      {clientIds.map(clientId => (
                        <Attendee
                          key={clientId}
                          clientId={clientId}
                          bookedClientIds={session.attendanceMap.booked}
                          onCheckInClicked={this.handleClickCheckIn}
                        />
                      ))}
                    </Grid>
                  </InfiniteScroller>
                </Grid>
              </>
            )}
          </Grid>
        </div>
      </>
    );
  }
}

const mapStateToProps = (
  { app: { error }, entities, ui: { clients, sessions } },
  { match }
) => {
  const sessionId = match.params.id;
  const session = entities.sessions.data[sessionId];
  const resources = entities.resources.data;

  const sessionEvent = session ? entities.events.data[session.eventId] : {};

  const sessionResources = session
    ? session.resourceIds.map(resourceId => resources[resourceId])
    : [];

  const sessionStaff = session
    ? session.staffIds.map(staffId => entities.staff.data[staffId])
    : [];

  return {
    clientIds: clients.ids,
    clients: entities.clients.data,
    error,
    event: sessionEvent,
    hasMore: clients.hasMore,
    isLoading: sessions.isLoading,
    isLoadingClients: clients.isLoading,
    page: clients.page,
    resources: sessionResources,
    session,
    staff: sessionStaff,
    totalCount: clients.totalCount,
  };
};

const mapDispatchToProps = (dispatch, { match }) => {
  const sessionId = match.params.id;

  return {
    fetchSession: () => dispatch(sessionActions.fetch(sessionId)),
    listClients: params =>
      dispatch(
        clientActions.list({
          ...params,
          sessionIds: [sessionId],
        })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceList);
